module.exports = __webpack_public_path__ + "img/27_42.4e013167.png";